import type { RotasDoModulo } from '@/app/rotas';

import { TermsAcceptancesPage } from './TermsAcceptancesPage';

/** A tela de aceites do termo de uso e das declaracoes da proposta (P-USU-2). */
export const rotas: RotasDoModulo = {
  menu: { '/termos-aceite': TermsAcceptancesPage },
};
